import React from "react";
import RootUserDashboard from "../component/home/root-user-dashboard";
import OverviewDashboad from "./overview/OverviewDashboard";
import OverviewIndex from "./overview/OverviewIndex";

const Home = (props) => {
  if (props.user.type === "ROOT") return <RootUserDashboard {...props} />;
  return <OverviewIndex {...props} />;
};

Home.auth = { path: "/", role: "ALL" };
export default Home;
